import Vue from 'vue'
import VueRouter from "vue-router"

import login from "../views/login.vue"

import final from "../views/final.vue"

import WhatBt from "../components/FirstUse/software/WhatBt.vue"
import WachBt from "../components/FirstUse/software/WachBt.vue"
import BuildDeposit from "../components/FirstUse/software/BuildDeposit.vue"
import BuildPackage from "../components/FirstUse/software/BuildPackage.vue"
import BmsEnter from "../components/FirstUse/software/BmsEnter.vue"
import LendRatio from "../components/FirstUse/software/LendRatio.vue"
import Position from "../components/FirstUse/software/Position.vue"


Vue.use(VueRouter)

const routes = [
  // 根目录
  {
    path: "/",
    redirect:"/login",
  },

  // 主页
  {
    path: "/final",
    name: "Final",
    component: final,
    // 嵌套路由 
    children:[
      
      {path: '/final/EVChargeSpots',component: ()=>import('../components/EVcharging/EVChargeSpots.vue') },
      {path: '/final/BatteryHardware',component: ()=>import('../components/FirstUse/BatteryHardware.vue') },
      {path: '/final/RevisePackage',component: ()=>import('../components/advance/DepositAndPackage/RevisePackage.vue')},
      {path: '/final/AddRent',component: ()=>import('../components/advance/DepositAndPackage/AddRent.vue')},
      //修改押金
      {
        path: '/final/ReviseDeposit',
        component: ()=>import('../components/YunYing/ReviseDeposit/ReviseDeposit.vue')
      },
      {
        path: '/final/OffDeposit',
        component: ()=>import('../components/YunYing/ReviseDeposit/OffDeposit.vue')
      },
      //退押金
      {
        path: '/final/ReviewDeposit',
        component: ()=>import('../components/YunYing/DepositRefund/ReviewDeposit.vue')
      },
      {
        path: '/final/AppReviewDeposit',
        component: ()=>import('../components/YunYing/DepositRefund/AppReviewDeposit.vue')
      },

      {
        path: '/final/AppOfflineDeposit',
        component: ()=>import('../components/YunYing/DepositRefund/AppOfflineDeposit.vue')
      },
      {
        path: '/final/OnLine',
        component: ()=>import('../components/YunYing/DepositRefund/OnLine.vue')
      },
      {
        path: '/final/OfflineDepositRefund',
        component: ()=>import('../components/YunYing/DepositRefund/OfflineDepositRefund.vue')
      },
      //
      {
        path: '/final/ReviseCombo',
        component: ()=>import('../components/YunYing/ReviseCombo.vue')
      },
      //绑押金套餐
      {
        path: '/final/AppBindCombo',
        component: ()=>import('../components/YunYing/BindDepositCombo/AppBindCombo.vue')
      },
      {
        path: '/final/BindCombo',
        component: ()=>import('../components/YunYing/BindDepositCombo/BindCombo.vue')
      },
      {
        path: '/final/AppBindDeposit',
        component: ()=>import('../components/YunYing/BindDepositCombo/AppBindDeposit.vue')
      },
      {
        path: '/final/BindDeposit',
        component: ()=>import('../components/YunYing/BindDepositCombo/BindDeposit.vue')
      },
      //其他
      {
        path: '/final/name',
        component: ()=>import('../components/qita/name.vue')
      },
      {
        path: '/final/Contract',
        component: ()=>import('../components/qita/Contract.vue')
      },
      //解绑电池
      {
        path: '/final/UnBindBattery',
        component: ()=>import('../components/YunYing/UnBindBattery/UnBindBattery.vue')
      },
      {
        path: '/final/AppUnBindBattery',
        component: ()=>import('../components/YunYing/UnBindBattery/AppUnBindBattery.vue')
      },
      //领电池
      {
        path: '/final/HowBindBirder',
        component: ()=>import('../components/YunYing/BindBirder/HowBindBirder.vue')
      },
      {
        path: '/final/WhenBindBirder',
        component: ()=>import('../components/YunYing/BindBirder/WhenBindBirder.vue')
      },
      //体验换电
      {
        path: '/final/ReviewDeposit',
        component: ()=>import('../components/shicao/ReviewDeposit.vue')
      },
      {
        path: '/final/DepositRefund',
        component: ()=>import('../components/shicao/DepositRefund.vue')
      },
      {
        path: '/final/ReturnsBattery',
        component: ()=>import('../components/shicao/ReturnsBattery.vue')
      },
      {
        path: '/final/CabinetLocation',
        component: ()=>import('../components/shicao/CabinetLocation.vue')
      },
      {
        path: '/final/BatteryPower',
        component: ()=>import('../components/shicao/BatteryPower.vue')
      },
      {
        path: '/final/CabinetShow',
        component: ()=>import('../components/shicao/CabinetShow.vue')
      },
      {
        path: '/final/BuyDeposit',
        component: ()=>import('../components/shicao/BuyDeposit.vue')
      },
      //手机首次
      {
        path: '/final/kehuanbi',
        component: ()=>import('../components/FirstApp/kehuanbi.vue')
      },
      {
        path: '/final/ReadBattery',
        component: ()=>import('../components/FirstApp/ReadBattery.vue')
      },
      {
        path: '/final/DevicePositioning',
        component: ()=>import('../components/FirstApp/DevicePositioning.vue')
      },
      //
      {
        path: '/final/Aerial',
        component: ()=>import('../components/CabinetInstall/Aerial.vue')
      },
      //开门
      {
        path: '/final/LockOpen',
        component: ()=>import('../components/CabinetInstall/Open/LockOpen.vue')
      },
      {
        path: '/final/LcdOpen',
        component: ()=>import('../components/CabinetInstall/Open/LcdOpen.vue')
      },
      {
        path: '/final/WebOpen',
        component: ()=>import('../components/CabinetInstall/Open/WebOpen.vue')
      },
      {
        path: '/final/AppOpen',
        component: ()=>import('../components/CabinetInstall/Open/AppOpen.vue')
      },
      //
      {
        path: '/final/DeviceNo',
        component: ()=>import('../components/CabinetInstall/DeviceNo.vue')
      },
      {
        path: '/final/WiringMethod',
        component: ()=>import('../components/CabinetInstall/WiringMethod.vue')
      },
      {
        path: '/final/WiringSize',
        component: ()=>import('../components/CabinetInstall/WiringSize.vue')
      },
      {
        path: '/final/Adminapp',
        component: ()=>import('../components/CabinetInstall/Adminapp.vue')
      },
      // 
      {
        path: '/final/NewCombo',
        component: ()=>import('../components/FirstPc/NewCombo.vue')
      },
      {
        path: '/final/NewDeposit',
        component: ()=>import('../components/FirstPc/NewDeposit.vue')
      },
      {
        path: '/final/InputBattery',
        component: ()=>import('../components/FirstPc/InputBattery.vue')
      },
      {
        path: '/final/CabinetShow',
        component: ()=>import('../components/CabinetShow.vue')
      },

      // 分割
      {
        path: '/final/AddNumber',
        component: ()=>import('../components/FirstUse/hardware/AddNumber.vue')
      },
      {
        path: '/final/DeviceNumber',
        component: ()=>import('../components/FirstUse/hardware/DeviceNumber.vue')
      },
      {
        path: '/final/BindDeposit',
        component: ()=>import('../components/advance/DepositAndPackage/BindDeposit.vue')
      },
      {
        path: '/final/BindPackage',
        component: ()=>import('../components/advance/DepositAndPackage/BindPackage.vue')
      },
      {
        path: '/final/BuyDeposit',
        component: ()=>import('../components/FirstUse/UserUse/BuyDeposit.vue')
      },
      {
        path: '/final/UserID',
        component: ()=>import('../components/FirstUse/UserUse/UserID.vue')
      },
      // 相对路径
      {
        path: 'Position',
        component: Position
      },
      {
        path: 'LendRatio',
        component: LendRatio
      },
      {
        path: 'BmsEnter',
        component: BmsEnter
      },
      {
        path: 'BuildPackage',
        component: BuildPackage
      },
      {
        path: 'BuildDeposit',
        component: BuildDeposit
      },
      {
        path: 'WachBt',
        component: WachBt
      },
      {
        path: 'WhatBt',
        component: WhatBt
      },
      {
        path: '/final/camera',
        component: ()=>import('../components/FirstUse/hardware/camera.vue')
      },
      {
        path: '/final/EnergizingADevice',
        component: ()=>import('../components/FirstUse/hardware/EnergizingADevice.vue')
      },
      {
        path: '/final/ReplaceBattery',
        component: ()=>import('../components/FirstUse/ReplaceBattery.vue')
      },
      {
        path: '/final/opendoor',
        component: ()=>import('../components/FirstUse/hardware/OpenDoor.vue')
      },
      {
        path: '/final/antennae',
        component: ()=>import('../components/FirstUse/hardware/antennae.vue')
      },
      {
        path: '/final/RemoveFenPcb',
        component: ()=>import('../components/HardwareReplacement/RemoveFenPcb.vue') 
      },
      {
        path: '/final/RemoveCharger',
        component: ()=>import('../components/HardwareReplacement/RemoveCharger.vue')
      },
      {
        path: '/final/InstalChargingLine',
        component: ()=>import('../components/HardwareReplacement/InstalChargingLine.vue')
      },
      {
        path: '/final/RemoveChargingLine',
        component: ()=>import('../components/HardwareReplacement/RemoveChargingLine.vue')
      },
      {
        path: '/final/ReplacementLock',
        component: ()=>import('../components/HardwareReplacement/ReplacementLock.vue')
      },
      {
        path: '/final/RelieveBatter',
        component: ()=>import('../components/advance/OperateBattery/RelieveBatter.vue')
      },
      {
        path: '/final/BindBatter',
        component: ()=>import('../components/advance/OperateBattery/BindBatter.vue')
      },
      {
        path: '/final/HowBindBatter',
        component: ()=>import('../components/advance/OperateBattery/HowBindBatter.vue')
      },
      {
        path: '/final/HowRelieveBatter',
        component: ()=>import('../components/advance/OperateBattery/HowRelieveBatter.vue')
      },
      {
        path:'/final/horsemanuse',
        component: ()=>import('../components/FirstUse/HorsemanUse.vue')
      },
      {
        path : '/final/tests',
        component: ()=>import('../components/FirstUse/hardware/tests.vue') 
      },
    ]
  },
  {
    // 一个大括号代表一个路由，代表一个要跳转的组件
    // 路径
    path: "/Charge",
    // 名称
    name: "charge",
    // 跳转的组件（名字要和引入时取得名字一致）
    component: ()=>import('../views/Charge.vue') ,
    children:[
      {
        path : '/Charge/ComboSet',
        component: ()=>import('../components/Charge/YunYing/ComboSet.vue') 
      },
      {
        path : '/Charge/ChargeShow',
        component: ()=>import('../components/Charge/ChargeShow.vue') 
      },
      {
        path : '/Charge/ChargeShow2',
        component: ()=>import('../components/Charge/ChargeShow2.vue') 
      },
      {
        path : '/Charge/ChargeInstall',
        component: ()=>import('../components/Charge/ChargeInstall.vue') 
      },
      {
        path : '/Charge/ChargePosition',
        component: ()=>import('../components/Charge/ChargePosition.vue') 
      },
      {
        path : '/Charge/ChargeToll',
        component: ()=>import('../components/Charge/PCsetting/ChargeToll.vue') 
      },
      {
        path : '/Charge/combo',
        component: ()=>import('../components/Charge/PCsetting/Chargecombo.vue') 
      },
      {
        path : '/Charge/UseCharge',
        component: ()=>import('../components/Charge/YunYing/UseCharge.vue') 
      },
      {
        path : '/Charge/AppDuankou',
        component: ()=>import('../components/Charge/YunYing/AppDuankou.vue') 
      },
      {
        path : '/Charge/shbeixinxi',
        component: ()=>import('../components/Charge/YunYing/shbeixinxi.vue') 
      },
      {
        path : '/Charge/Adminapp',
        component: ()=>import('../components/CabinetInstall/Adminapp.vue') 
      },
      {
        path : '/Charge/question1',
        component: ()=>import('../components/Charge/question/question1.vue') 
      },
    ] 
  },
  {
    // 一个大括号代表一个路由，代表一个要跳转的组件
    // 路径
    path: "/test1",
    // 名称
    name: "test1",
    // 跳转的组件（名字要和引入时取得名字一致）
    component: ()=>import('../views/test1.vue') ,
    children:[
      {
        path : '/test1/tests',
        component: ()=>import('../components/FirstUse/hardware/tests.vue') 
    },
    {
      path: '/test1/AddNumber',
      component: ()=>import('../components/FirstUse/hardware/AddNumber.vue')
    },
 
    ] 
  },

  {
    path: "/test2",
    name: "test2",
    component: ()=>import('../views/test2.vue') ,
    children:[
      {
        path : '/test2/tests',
        component: ()=>import('../components/FirstUse/hardware/tests.vue') 
    },
    {
      path: '/test2/AddNumber',
      component: ()=>import('../components/FirstUse/hardware/AddNumber.vue')
    },
 
    ] 
  },
  
  


  // 登录页
  {
    // 一个大括号代表一个路由，代表一个要跳转的组件
    // 路径
    path: "/login",
    // 名称
    name: "Login",
    // 跳转的组件（名字要和引入时取得名字一致）
    component: login
  },

]

const router = new VueRouter({
  routes
})

export default router
